export class FieldState {
  private static _fieldIdCounter: number = 0;
  public static generateFieldId() {
    this._fieldIdCounter++;
    return this._fieldIdCounter;
  }

  public fieldId: number;
  public isInEditMode: boolean;
  public isValid: boolean;
  public message: string;
  public messageType: string;
  //TODO
  public messageClass: string = 'error';

  public reset() {
    this.isInEditMode = false; //TODO false by default ? ili odbavit parmater default editing state?
    this.isValid = true;
    this.message = null;
  }

  public modelFieldGetter: () => any;
  public valueChecker: () => boolean;

  public get hasValue() {
    if (this.valueChecker != null) {
      return this.valueChecker();
    } else if (this.modelFieldGetter != null) {
      return this.modelFieldGetter() !== null;
    } else {
      throw Error('No value checker or field getter provided');
    }
  }

  constructor(
    fieldGetter?: () => any,
    valueChecker?: () => boolean,
    fieldId?: number
  ) {
    this.isInEditMode = false;
    this.isValid = true;
    this.message = null;
    this.modelFieldGetter = fieldGetter;
    this.valueChecker = valueChecker;
    this.fieldId = fieldId || FieldState.generateFieldId();
  }
}
